
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"userPermalink":"Permalink erstellen","extendedPermalink":"Erweiterten Permalink erstellen"},"en":{"userPermalink":"Create Permalink","extendedPermalink":"Create Extended Permalink"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();